module.exports = __webpack_public_path__ + "static/img/tst2-06-1.40ec500.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-06-1.gif
// module id = od7Z
// module chunks = 1